import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getCarBodyType } from './carThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearCarKey } from '../../sell/sellKeys';
const SLICE_NAME = 'bodyType';

export const bodyTypeSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        data: [],
        isLoading: false,
        error: null,
    },
    reducers: {
        clearCarBodyType(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCarBodyType });
        builder.addCase(clearCarKey, () => commonInitialState);
    },
});

export const { clearCarBodyType } = bodyTypeSlice.actions;

export const bodyType = bodyTypeSlice.reducer;
